import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { Fragment, useState } from 'react';
import { FiRefreshCw } from 'react-icons/fi';
import { IoSettingsOutline } from 'react-icons/io5';
import { IoExpand } from 'react-icons/io5';
import { FiMinimize } from 'react-icons/fi';
import DropDownSettings from './DropDownSettings';
import { LANG_OPTION } from '@lib/constants';
import Link from 'next/link';

function OptionsHeader({
  optionsData,
  selectedLang,
  setLang,
  hideOptions,
  resetHandler,
  headerConfig,
  setHeaderConfig,
}) {
  return (
    <>
      <div className="mb-4 flex h-12 items-center justify-between gap-2 px-8 text-white">
        {optionsData?.languages?.length > 0 && (
          <>
            <Menu as="div">
              {({ open, close }) => {
                return (
                  <>
                    <Menu.Button className="flex w-full items-center justify-between bg-[#1A1A1A] px-3 py-0.5 font-satoshi-medium text-base font-medium  capitalize shadow-lg focus:outline-none">
                      <span>{LANG_OPTION[selectedLang] || selectedLang}</span>
                      <span>
                        <ChevronDownIcon className="-mr-1 ml-2 h-5 w-5" aria-hidden="true" />
                      </span>
                    </Menu.Button>

                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="bg-module-theme absolute z-20 mt-2 w-max origin-top-left rounded-md capitalize shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div className="bg-[#1A1A1A] py-1">
                          {optionsData?.languages?.map((name, id) => (
                            <Menu.Item key={id}>
                              <Link
                                href={`/online-compiler/${name}`}
                                as={`/online-compiler/${name}`}
                                passHref
                              >
                                <a
                                  className={
                                    (selectedLang === name
                                      ? 'text-learn-primary font-satoshi-bold font-bold '
                                      : 'text-black',
                                    'block cursor-pointer px-6 py-2 text-sm')
                                  }
                                  onClick={() => {
                                    setLang(name);
                                    close();
                                  }}
                                >
                                  {LANG_OPTION[name] || name}
                                </a>
                              </Link>
                            </Menu.Item>
                          ))}
                        </div>
                      </Menu.Items>
                    </Transition>
                  </>
                );
              }}
            </Menu>
            {!hideOptions && (
              <div className="flex items-center gap-x-4 md:gap-x-2">
                <button
                  className="hidden cursor-pointer bg-[#1A1A1A] px-2 py-1 md:block"
                  onClick={() =>
                    setHeaderConfig((prev) => ({ ...prev, fullScreen: !prev.fullScreen }))
                  }
                >
                  {!headerConfig.fullScreen ? <IoExpand /> : <FiMinimize />}
                </button>
                {selectedLang !== 'react' && (
                  <button className="cursor-pointer bg-[#1A1A1A] px-2 py-1" onClick={resetHandler}>
                    <FiRefreshCw />
                  </button>
                )}
                <button
                  className="cursor-pointer bg-[#1A1A1A] px-2 py-1"
                  onClick={(e) => {
                    e.stopPropagation();
                    setHeaderConfig((prev) => ({ ...prev, openConfig: !headerConfig.openConfig }));
                  }}
                >
                  <IoSettingsOutline />

                  {headerConfig.openConfig && (
                    <DropDownSettings config={headerConfig} setConfig={setHeaderConfig} />
                  )}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default OptionsHeader;
